<template>
  <div class="content" v-show="isShow">
    <div class="recruit-canvas">
      <div class="canvas-out-box">
        <div class="canvas-box" ref="canvasRef">
          <canvas ref="canvasMapRef" id="canvas-map" width="100" height="100" />
        </div>
      </div>
      <div class="btn-box flex-row">
        <van-button @click="clearHandle" class="no-use">重绘</van-button>
        <van-button @click="confirmHandle" type="info">确认</van-button>
      </div>
      <slot name="default" :signatrue="canvasNode"></slot>
    </div>
  </div>
</template>

<script>
import config from '@/configs/config'
import SignaturePad from 'signature_pad'
import { rotateBase64Img } from './sign' //这是使用的方法，当手机屏幕是竖屏的时候要旋转图片

export default {
  props: {
    isShow: {
      type: Boolean,
      require: true
    }
  },
  data() {
    return {
      canvasNode: null,
      signPic: '',
      flag: true,
      savedSignature: '',
      resizeTimer: null
    }
  },
  watch: {
    isShow(newV) {
      if (newV) {
        tuhu.toast('请横屏签字')
        this.$nextTick(() => {
          this.restoreSignature()
          window.addEventListener('resize', this.handleResize)
        })
      } else {
        this.saveSignature()
        window.removeEventListener('resize', this.handleResize)
      }
    }
  },
  beforeDestroy() {
    this.saveSignature()
    window.removeEventListener('resize', this.handleResize)
    if (this.resizeTimer) clearTimeout(this.resizeTimer)
  },
  methods: {
    saveSignature() {
      if (this.canvasNode && !this.canvasNode.isEmpty()) {
        this.savedSignature = this.canvasNode.toDataURL()
      }
    },

    restoreSignature() {
      if (this.savedSignature && this.$refs.canvasMapRef) {
        const ctx = this.$refs.canvasMapRef.getContext('2d')
        const img = new Image()

        img.onload = () => {
          const canvasBox = this.$refs.canvasRef
          ctx.canvas.width = canvasBox.clientWidth
          ctx.canvas.height = canvasBox.clientHeight
          ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
          ctx.drawImage(img, 0, 0, ctx.canvas.width, ctx.canvas.height)
          this.initalHandle()
        }
        img.src = this.savedSignature
      } else {
        this.initalHandle()
      }
    },

    handleResize() {
      if (this.isShow) {
        clearTimeout(this.resizeTimer)
        this.resizeTimer = setTimeout(() => {
          this.restoreSignature()
        }, 200)
      }
    },

    initalHandle() {
      const _canvasBox = this.$refs.canvasRef
      const _canvas = this.$refs.canvasMapRef
      if (!_canvasBox || !_canvas) return false

      _canvas.width = _canvasBox.clientWidth
      _canvas.height = _canvasBox.clientHeight

      const computedOpt = {
        minWidth: 4,
        maxWidth: 4,
        penColor: 'rgb(0, 0, 0)',
        dotSize: radius => (radius < 3 ? 1 : Math.ceil(radius / 8))
      }

      this.canvasNode = new SignaturePad(_canvas, computedOpt)
    },

    clearHandle() {
      if (this.canvasNode) {
        this.canvasNode.clear()
        this.savedSignature = ''
      }
    },

    async confirmHandle() {
      if (!this.canvasNode) this.initalHandle()

      if (this.canvasNode.isEmpty()) {
        tuhu.toast('您还没有签名')
        return false
      }
      const _boxWidth = window.innerWidth
      const _boxHeight = window.innerHeight
      const _signImg = this.canvasNode.toDataURL('image/png', 0.6) || null //不旋转就是手机横屏
      if (_boxWidth < _boxHeight) {
        await rotateBase64Img(_signImg, -90, imgUrlRes => {
          //在这里修改逻辑，返回的是旋转后的database
          this.imgBase64ToUrl(imgUrlRes)
        })
      } else {
        this.imgBase64ToUrl(_signImg)
      }
      // const _signImg = this.canvasNode.toDataURL('image/png', 0.6)
      // await this.imgBase64ToUrl(_signImg)
    },

    async imgBase64ToUrl(data) {
      if (!this.flag) return
      this.flag = false

      const params = {
        baseFile: data,
        fileName: '签名.png'
      }

      try {
        const res = await tuhu.fetch(config.apis.UploadBase64File, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(params)
        })

        if (res.code === '200') {
          this.signPic = res.data
          this.$emit('close', this.signPic)
        } else {
          tuhu.toast(res.message || '上传失败')
        }
      } catch (err) {
        console.error('上传错误', err)
        tuhu.toast('请求异常')
      } finally {
        this.flag = true
      }
    }
  }
}
</script>

<style scoped lang="less">
@media screen and (orientation: portrait) {
  /*竖屏 css*/
  .content {
    top: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    .title {
      color: black;
    }
    .recruit-canvas {
      top: 3rem;
      position: fixed;
      background-color: white;
      flex-direction: column;
      width: 28rem;
      height: 15.25rem;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(90deg);
      background: #ffffff;
      box-shadow: 0rem 0.05rem 0.48rem 0rem rgba(185, 185, 185, 0.02);
      border-radius: 0.5rem;
      overflow: hidden;
      position: absolute;

      .canvas-out-box {
        width: 28rem;
        height: 13.25rem;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;

        .canvas-box {
          transform: rotate(270deg);
          width: 13.25rem;
          height: 28rem;
          overflow: hidden;
          background-color: #fff;

          #canvas-map {
            width: 100%;
            height: 100%;
          }
        }
      }

      .btn-box {
        z-index: 1000;
        width: 28rem;
        padding: 0 2.03rem 1.5rem;
        height: 2.3rem !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        white-space: nowrap;

        .van-button {
          font-weight: 500;
          font-size: 0.75rem;
          border-radius: 1.1rem;
          width: 9.85rem;
          height: 1.8rem;
        }

        .van-button:nth-of-type(1) {
          border: 0.03rem solid #4b6af7;
          margin-right: 1.5rem;
          color: #4b6af7;
          line-height: 0.75rem;
        }

        .van-button:nth-of-type(2) {
          color: #ffffff;
          line-height: 0.75rem;
        }
      }
    }
  }
}

@media screen and (orientation: landscape) {
  /*横屏 css*/
  .content {
    top: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    .title {
      color: #808080;
    }
    .recruit-canvas {
      top:2rem;
      left:2rem;
      margin:auto;
      position: fixed;
      background-color: white;
      flex-direction: column;
      width: 22rem;
      height: 10.25rem;
      background: #ffffff;
      box-shadow: 0rem 0.05rem 0.48rem 0rem rgba(185, 185, 185, 0.02);
      border-radius: 0.5rem;
      overflow: hidden;
      position: absolute;

      .canvas-out-box {
        width: 22rem;
        height: 8.25rem;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;

        .canvas-box {
          width: 20rem;
          height: 8.25rem;
          overflow: hidden;
          transform: translateY(0);
          background-color: #fff;

          #canvas-map {
            width: 100%;
            height: 100%;
          }
        }
      }

      .btn-box {
        z-index: 1000;
        width: 20rem;
        padding: 0 1.03rem 1.5rem;
        height: 1.2rem !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        white-space: nowrap;

        .van-button {
          font-weight: 500;
          font-size: 0.75rem;
          border-radius: 1.1rem;
          width: 9.85rem;
          height: 1.2rem;
        }

        .van-button:nth-of-type(1) {
          border: 0.03rem solid #4b6af7;
          margin-right: 1.5rem;
          color: #4b6af7;
          line-height: 0.75rem;
        }

        .van-button:nth-of-type(2) {
          color: #ffffff;
          line-height: 0.75rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/signPad.vue